const supervisor = {
    'TITLE': 'Supervisor',
    'SHIFT': 'Shift',
    'DATE': 'Date',
    'CAMPAIGN': 'Campaign',
    'CREATED_AT': 'Create At',
    'CREATED_DATE': 'Create Date',
    'CREATED_BY': 'Create By',
    'UPDATE_DATE': 'Updated Date',
    'UPDATE_BY': 'Updated By',
    'FILTER': 'Filter',
    'DELETE': 'Delete',
    'TITLE_CONF': 'Delete Supervisor',
    'MESSAGE': 'Are you sure you want to delete this supervisor?',
    'TITLE_EDIT': 'Edit Supervisor',
};

export default supervisor;